module.exports = __webpack_public_path__ + "77e0c2df218f53107e5abae770dc18b3.pdf";